export const blockIconsMapsLocalActivity = (
	<span className='material-symbols-outlined'>local_activity</span>
);
